import { QueryOptionsType, Product } from '@framework/types';
import http from '@framework/utils/http';
import { API_ENDPOINTS } from '@framework/utils/api-endpoints';
import { useQuery } from 'react-query';
export const fetchMainProducts = async ({
  queryKey
}: any) => {
  const [_key, _params] = queryKey;
  const {
    data
  } = await http.get(API_ENDPOINTS.MAIN_PRODUCTS + '?has_promotion=1', {
    params: _params
  });
  if (data.count === 0) {
    const {
      data
    } = await http.get(API_ENDPOINTS.MAIN_PRODUCTS + '?is_popular=1', {
      params: _params
    });
    data.results.forEach((item: any) => item.headerCategory = 'popular');
    return data.results as Product[];
  }
  data.results.forEach((item: any) => item.headerCategory = 'promo');
  return data.results as Product[];
};
export const useMainProductsQuery = (options: QueryOptionsType) => {
  return useQuery<Product[], Error>([API_ENDPOINTS.MAIN_PRODUCTS, options], fetchMainProducts, {
    refetchOnWindowFocus: false,
    refetchOnReconnect: false
  });
};